import { TiTick } from "react-icons/ti";
import bannerImg from '../../assets/images/team-working-on-mobile-app-project.avif'
import {Banner,AppDevelopmentSolutions,GrayTextBoxLayout,BrainstormingMobileAppIdea,TechWeUse, Faq} from './components'
function MobileAppDevelopment() {
  return (
      <section className="space-y-20 md:space-y-32 mb-20 md:mb-32">
    <Banner/>
    <AppDevelopmentSolutions/>
    <GrayTextBoxLayout/> 
    <BrainstormingMobileAppIdea/>
    <TechWeUse/>
    <Faq/>
    </section>
  );
}
export default MobileAppDevelopment;
